import { Shift, Store } from '@nextforce/api'
import React from 'react'
import { StyleSheet } from 'react-native'
import { PressableOpacity } from '../pressable_opacity'
import { ShiftStoreAddressView } from './address'
import { ShiftDistanceView } from './distance'

interface Props {
  shift: Shift
  showApprover: boolean
  onStorePress?: (store: Store) => void
}

export function ShiftStoreView({ shift, showApprover, onStorePress }: Props) {
  return (
    <PressableOpacity
      style={styles.container}
      onPress={() => {
        onStorePress?.(shift.store)
      }}
    >
      <ShiftDistanceView distance={shift.distance} />
      <ShiftStoreAddressView shift={shift} showApprover={showApprover} />
    </PressableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
  },
})
